module.exports = __webpack_public_path__ + "static/media/FIT.2676be9b.jpg";